export function TurnOff(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.07157 3.1365C4.36394 3.46775 4.33242 3.9733 4.00117 4.26568C3.0587 5.09752 2.46621 6.31201 2.46621 7.66588C2.46621 10.1696 4.49585 12.1992 6.99954 12.1992C9.50323 12.1992 11.5329 10.1696 11.5329 7.66588C11.5329 6.31201 10.9404 5.09752 9.99792 4.26568C9.66667 3.9733 9.63515 3.46775 9.92752 3.1365C10.2199 2.80524 10.7254 2.77372 11.0567 3.06609C12.3287 4.18877 13.1329 5.83391 13.1329 7.66588C13.1329 11.0532 10.3869 13.7992 6.99954 13.7992C3.6122 13.7992 0.866211 11.0532 0.866211 7.66588C0.866211 5.83391 1.67041 4.18877 2.94239 3.06609C3.27365 2.77372 3.7792 2.80524 4.07157 3.1365Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.99954 0.199219C7.44137 0.199219 7.79954 0.557391 7.79954 0.999219V5.33255C7.79954 5.77438 7.44137 6.13255 6.99954 6.13255C6.55772 6.13255 6.19954 5.77438 6.19954 5.33255V0.999219C6.19954 0.557391 6.55772 0.199219 6.99954 0.199219Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
